const destinations = [
  {
    name: "Dubai & UAE",
    context: "Energy industry conferences, ADIPEC petroleum expo, oil and gas business development from OKC's energy corridor",
    urgency: "Executive travel often booked with 5–10 days notice from downtown OKC firms",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "London energy finance meetings, BP and Shell partnerships, international conferences for OU Health professionals",
    urgency: "Corporate and medical travel has 7–14 day lead time in many cases",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Japan",
    context: "Energy industry partnerships, medical conferences in Tokyo, Tinker AFB OCONUS assignments to Okinawa",
    urgency: "6-month validity required. Many OKC travelers discover expired passports 2–3 weeks before departure",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico & Caribbean",
    context: "Family beach vacations, spring break trips from OCCC and surrounding colleges, direct charters from OKC to Cancun",
    urgency: "Last-minute Cancun charters and cruise bookings peak March through August",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy & Europe",
    context: "Heritage tourism from Oklahoma's Italian-American community, church pilgrimage travel, OU study abroad connections",
    urgency: "Study-abroad deadlines create predictable October and February passport rush seasons",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Calgary energy industry partnerships, Banff ski trips, Niagara Falls family vacations, Toronto business",
    urgency: "Summer energy conference season peaks June through September",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "60%",
    label: "of OKC expedited requests involve energy industry travel or Tinker AFB military PCS orders",
  },
  {
    stat: "2–5 Weeks",
    label: "average notice OKC energy professionals have before an international business trip",
  },
  {
    stat: "May–Aug",
    label: "peak season when PCS orders, energy conferences, and family vacations collide",
  },
  {
    stat: "48 Hours",
    label: "shortest energy executive turnaround we have accommodated for a downtown OKC Devon Energy client",
  },
];

export default function OKCDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Oklahoma City Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Central Oklahoma clients. Understanding local travel behavior is part of why our document review catches issues before they derail your energy conference, PCS move, or family vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Oklahoma Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Oklahoma with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/tulsa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tulsa <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/norman" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Norman <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/broken-arrow" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Broken Arrow <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}